<template>
  <CancelPercentageBase
    :yellowThreshold="yellowThreshold"
    :redThreshold="redThreshold"
    :percentage="percentage"
    :numberSize="numberSize"
    :numberClass="numberClass"
    :unitSize="unitSize"
    :unitClass="unitClass"
  />
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import CancelPercentageBase from "@/components/molecules/other/CancelPercentageBase.vue";

const YELLOW_THRESHOLD = 10;
const RED_THRESHOLD = 20;

@Component({ components: { CancelPercentageBase } })
export default class CancelPercentageSudden extends Vue {
  @Prop({ required: true, type: Number }) percentage!: number;
  @Prop({ required: false, type: String }) numberSize?: string;
  @Prop({ required: false, type: String }) numberClass?: string;
  @Prop({ required: false, type: String }) unitSize?: string;
  @Prop({ required: false, type: String }) unitClass!: string;

  get yellowThreshold() {
    return YELLOW_THRESHOLD;
  }

  get redThreshold() {
    return RED_THRESHOLD;
  }
}
</script>
